import Vue from 'vue'
import Vuex from 'vuex'
import http from '@/api/http'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    initData: {},
    mediaqueryKey: 4,
    schedules: [],
    objectData: {},
    iconsFetched: false,
    schedulesFetched: false,
    categoriesFetched: false,
    deckplanFetched: false,
    idActiveCategory: 0,
    idActiveCabin: 0,
    selectedUnit: '',
    decks: [],
    media: {
      1: '(max-width: 479px)',
      2: '(min-width: 480px) and (max-width: 767px)',
      3: '(min-width: 768px) and (max-width: 991px)',
      4: '(min-width: 992px) and (max-width: 1919px)',
      5: '(min-width: 1920px)'
    }
  },
  getters: {
    schedule: state => (idxSchedule) => {
      return state.schedules[idxSchedule]
    }
  },
  mutations: {
    SET_INIT_DATA (state, payload) {
      state.initData = payload
    },
    SET_MEDIAQUERY_KEY (state, payload) {
      state.mediaqueryKey = payload
    },
    SET_OBJECT_DATA (state, payload) {
      state.objectData = payload
    },
    SET_SCHEDULES (state, payload) {
      state.schedules = payload
    },
    SET_SCHEDULES_FETCHED (state, payload) {
      state.schedulesFetched = payload
    },
    SET_CATEGORIES (state, payload) {
      state.schedules[payload.idxSchedule].categories = payload.categories
    },
    SET_DECKPLAN (state, payload) {
      state.decks.push(payload)
    },
    SET_CATEGORIES_FETCHED (state, payload) {
      state.categoriesFetched = payload
    },
    SET_DECKPLAN_FETCHED (state, payload) {
      state.deckplanFetched = payload
    },
    SET_ID_ACTIVE_CATEGORY (state, payload) {
      state.idActiveCategory = payload
    },
    SET_ID_ACTIVE_CABIN (state, payload) {
      state.idActiveCabin = payload
    },
    SET_SELECTED_UNIT (state, payload) {
      state.selectedUnit = payload
    }
  },
  actions: {
    getSchedules ({ commit, state }) {
      return http.getSchedules({
          packageCodes: state.initData.objectCode,
          language: state.initData.language.toUpperCase(),
          currency: state.initData.currency.toUpperCase(),
          idShip: state.initData.idShip,
          includeVirtualCategories: state.initData.guaranteeCategoryAvailable,
          idMediaObject: + state.initData.idMediaObject
        })
        .then(response => {
          commit('SET_SCHEDULES', response.schedules)
          commit('SET_OBJECT_DATA', response.objectData)
          return response.schedules
        })
        .then(response => {
          commit('SET_SCHEDULES_FETCHED', true)
          return response
        })
    },
    getCategories ({ commit, state }, idxSchedule) {
      commit('SET_CATEGORIES_FETCHED', false)
      http.getCategories({
        idPackageSchedule: state.schedules[idxSchedule].id
      })
        .then(response => {
          commit('SET_CATEGORIES', { categories: response, idxSchedule: idxSchedule })
        })
        .then(() => {
          commit('SET_CATEGORIES_FETCHED', true)
        })
    },
    getDeckplan ({ commit, state }, category) {
      let promises = []
      commit('SET_DECKPLAN_FETCHED', false)
      category.filenamesDeck.forEach( filename => {
        promises.push(
          http.getDeckplan({
            fileName: filename
          })
          .then(response => {
            commit('SET_DECKPLAN', response)
          })
        )
      })
      Promise.all(promises).then(() => {
        commit('SET_DECKPLAN_FETCHED', true)
      })
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})
